import { Link } from "react-router-dom";
import Badge from "../../shared/Badge";
import { formatDate } from "../../utils";
import {
  renderCustomColumnDefs,
  renderValidations,
} from "../../shared/Table/table.utils";
import {
  getComplianceProfileLabel,
  getManifestStatusColor,
  getManifestStatusLabel,
} from "./utils";

const tableConfig = [
  {
    id: "manifestNumber",
    header: "Manifest #",
    visible: true,
    cell: ({ row: { original }, getValue }) => (
      <Link
        className="text-primary-600 hover:underline"
        to={`/manifests/v2/${original._id}`}
      >
        {getValue()}
      </Link>
    ),
  },
  {
    id: "status",
    visible: true,
    cell: ({ getValue }) => (
      <Badge
        color={getManifestStatusColor(getValue())}
        label={getManifestStatusLabel(getValue())}
      />
    ),
  },
  {
    id: "complianceProfile",
    header: "Profile",
    visible: true,
    cell: ({ getValue }) => getComplianceProfileLabel(getValue()),
  },
  {
    id: "driver",
    visible: true,
    cell: ({ getValue }) => getValue()?.fullName || "—",
  },
  {
    id: "legs",
    header: "Legs",
    visible: true,
    cell: ({ getValue }) => (Array.isArray(getValue()) ? getValue().length : 0),
  },
  {
    id: "totalMileage",
    header: "Miles",
    visible: true,
    cell: ({ getValue }) => Number(getValue() || 0).toFixed(1),
  },
  {
    id: "startDate",
    header: "Start Date",
    visible: true,
    cell: ({ getValue }) => formatDate(getValue(), null, true),
  },
  {
    id: "updatedAt",
    header: "Updated",
    visible: true,
    cell: ({ getValue }) => formatDate(getValue(), null, true),
  },
  {
    id: "_id",
    header: "id",
    visible: false,
    width: 230,
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
export const FORM_OPTIONS = { validations: renderValidations(tableConfig) };
export const PAGE_SIZE_OPTIONS = [
  { label: "10 Manifests", value: 10 },
  { label: "20 Manifests", value: 20 },
  { label: "50 Manifests", value: 50 },
  { label: "100 Manifests", value: 100 },
];
